"use client";

import { useState } from "react";
import { ArrowRight, Check, FileText, Home, Link2, MousePointer2 } from "lucide-react";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import type { GoogleVisibilityCopy } from "./google-visibility-copy";
import styles from "./google-visibility.module.scss";

export function CcGoogleSiteCheck({ copy }: { copy: GoogleVisibilityCopy["check"] }) {
  const [selected, setSelected] = useState(1);
  const node = copy.nodes[selected];
  return <section className={`cc-section ${styles.checkSection}`} id="google-check" aria-labelledby="google-check-title" data-cc-nav="light" data-cc-surface="light">
    <div className={styles.shell}>
      <div className={styles.sectionHeader}><CcSanjayaEyebrow>{copy.eyebrow}</CcSanjayaEyebrow><h2 id="google-check-title">{copy.title}</h2><p>{copy.text}</p></div>
      <div className={styles.checkFrame}>
        <div className={styles.map}>
          <div className={styles.mapHeader}><span className={styles.micro}>{copy.label}</span><MousePointer2 size={16} aria-hidden="true" /></div>
          <div className={styles.mapCanvas}>
            <svg viewBox="0 0 600 350" preserveAspectRatio="none" className={styles.mapLines} aria-hidden="true"><path d="M300 70 V165 H110 V235 M300 165 V235 M300 165 H490 V235" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="5 6" /></svg>
            {copy.nodes.map((item, index) => <button type="button" className={`${styles.mapNode} ${index === selected ? styles.selectedNode : ""}`} data-node={index} key={item.id} onClick={() => setSelected(index)} aria-pressed={index === selected} aria-controls="google-check-detail">
              <span className={styles.nodeIcon}>{index === 0 ? <Home size={20} /> : index === 3 ? <Check size={20} /> : <FileText size={20} />}</span><strong>{item.name}</strong><small>{item.path}</small><span className={styles.nodeStatus}>{item.status}</span>
            </button>)}
          </div>
          <p className={styles.mapNote}>{copy.note}</p>
        </div>
        <div className={styles.checkDetail} id="google-check-detail" aria-live="polite"><span className={styles.detailPath}><Link2 size={14} aria-hidden="true" />{node.path}</span><h3>{node.name}</h3><div><small>{copy.issueLabel}</small><p>{node.issue}</p></div><ArrowRight className={styles.detailArrow} size={22} aria-hidden="true" /><div><small>{copy.fixLabel}</small><p>{node.fix}</p></div></div>
      </div>
    </div>
  </section>;
}
